import { useEffect, useState } from "react";
import axiosInstance from "../../../axiosConfig";
import { handleError } from "../../../services/handleError";
import { showToast } from "../../Toast";
import Loading from "../../../pages/Loading"

export default function OpcoesPedidoConfig() {
    const [loading, setLoading] = useState(false);

    const [opcoesPedido, setOpcoesPedido] = useState({
        balcao: false,
        retirada: false,
        entrega: false,
    });
    const [configEntrega, setConfigEntrega] = useState({
        taxa: "",
        valorMinimo: "",
    });

    useEffect(() => {
        buscarOpcoesPedido();
    }, []);

    const buscarOpcoesPedido = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get("Configs/OpcoesPedido");
            setOpcoesPedido({
                balcao: res.data.atendeBalcao,
                retirada: res.data.atendeRetirada,
                entrega: res.data.atendeEntrega,
            });
            setConfigEntrega({
                taxa: res.data.taxaEntrega || "",
                valorMinimo: res.data.valorMinimoEntrega || "",
            });
        } catch (error) {
            handleError(error, "Erro ao buscar opções de pedido.");
        } finally {
            setLoading(false);
        }
    };

    const salvarOpcoesPedido = async () => {
        try {
            await axiosInstance.put("Configs/OpcoesPedido", {
                atendeBalcao: opcoesPedido.balcao,
                atendeRetirada: opcoesPedido.retirada,
                atendeEntrega: opcoesPedido.entrega,
                taxaEntrega: parseFloat(configEntrega.taxa || "0"),
                valorMinimoEntrega: parseFloat(configEntrega.valorMinimo || "0"),
            });
            showToast("Sucesso!", "success", 3000, "Configurações salvas com sucesso!");
        } catch (error) {
            handleError(error, "Erro ao salvar opções de pedido.");
        }
    };

    const handleToggle = (tipo, checked) => {
        setOpcoesPedido(prev => ({ ...prev, [tipo]: checked }));
    };

    const options = [
        { id: "balcao", label: "🛎️ Balcão", desc: "Pedido feito e consumido no local" },
        { id: "retirada", label: "📦 Retirada", desc: "Cliente busca o pedido no estabelecimento" },
        { id: "entrega", label: "🚚 Entrega", desc: "O pedido é entregue no endereço do cliente" },
    ];

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="w-full p-6 space-y-2 overflow-y-auto">
            <h2 className="text-2xl font-bold text-gray-900">Opções de Pedido</h2>
            <p className="text-gray-700">Escolha as formas de atendimento do seu estabelecimento.</p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-2">
                {options.map(opt => (
                    <label key={opt.id} className={`text-white flex flex-col items-start p-4 border rounded-xl shadow-md cursor-pointer transition-all duration-300 ${opcoesPedido[opt.id] ? 'bg-gradient-to-br from-blue-500 to-blue-700 border-blue-600 shadow-lg' : 'bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-900 dark:to-gray-800'}`}>
                        <div className="flex justify-between w-full items-center">
                            <span className="text-lg font-semibold">{opt.label}</span>
                            <input
                                type="checkbox"
                                className="hidden"
                                checked={opcoesPedido[opt.id]}
                                onChange={(e) => handleToggle(opt.id, e.target.checked)}
                            />
                            <div className={`w-12 h-6 flex items-center rounded-full p-1 transition-all duration-300 ${opcoesPedido[opt.id] ? "bg-white" : "bg-gray-300"}`}>
                                <div className={`w-5 h-5 rounded-full shadow-md transition-transform duration-300 ${opcoesPedido[opt.id] ? "translate-x-5 bg-gradient-to-br from-blue-500 to-blue-700" : "bg-gray-500"}`} />
                            </div>
                        </div>
                        <p className="text-sm mt-1">{opt.desc}</p>
                    </label>
                ))}
            </div>

            <div className={`p-5 border rounded-2xl shadow-md space-y-5 bg-gradient-to-br from-blue-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 border-blue-300 transition-all duration-300 ease-in-out transform ${opcoesPedido.entrega ? "max-h-[500px] opacity-100 translate-y-0 py-5" : "max-h-0 opacity-0 scale-95 py-0 overflow-hidden"}`}>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">🚚 Configurações de Entrega</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-gray-800 dark:text-gray-200 font-medium mb-1">Taxa de Entrega (R$)</label>
                        <input
                            type="number"
                            className="w-full p-3 border rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-blue-400"
                            value={configEntrega.taxa}
                            onChange={(e) => setConfigEntrega({ ...configEntrega, taxa: e.target.value })}
                        />
                    </div>
                    <div>
                        <label className="block text-gray-800 dark:text-gray-200 font-medium mb-1">Valor Mínimo do Pedido (R$)</label>
                        <input
                            type="number"
                            className="w-full p-3 border rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-blue-400"
                            value={configEntrega.valorMinimo}
                            onChange={(e) => setConfigEntrega({ ...configEntrega, valorMinimo: e.target.value })}
                        />
                    </div>
                </div>
            </div>

            <div className="flex justify-end pt-4">
                <button
                    onClick={salvarOpcoesPedido}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                >
                    Salvar
                </button>
            </div>
        </div>
    );
}